import React from 'react';
import {Dimensions, StyleSheet, View, Platform} from 'react-native';
import isWeb from '../utils/isWeb';
import WebDrawer from '../navigation/WebDrawer.web';
import {getCurrentUnitLink} from '../utils';
import { colorSwatches } from '../styles';

const height = Dimensions.get('window').height;

export default function Container(props) {
  const currentUnitLink = getCurrentUnitLink();
  const {
    children,
    style,
    fullWidth,
    hasDrawer = true,
    fullHeight = false,
    ...otherProps
  } = props;
  return (
    <View
      style={{
        alignSelf: 'stretch',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        width: '100%',
        flex: 1,
      }}>
      {!!currentUnitLink && hasDrawer && isWeb && <WebDrawer />}
      <View
        {...otherProps}
        style={[
          styles.container,
          style,
          {
            maxWidth: fullWidth ? undefined : 1140,
          },
        ]}>
        <View
          //@ts-ignore
          style={{
            flex: 1,
            width: '100%',
            minWidth: 0,
            height: isWeb ? '100vh' : height,
            backgroundColor: colorSwatches.white.color,
          }}>
          {children}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flex: 1,
    width: '100%',
    minWidth: 0,
    justifyContent: 'center',
  },
});
